import { SupportedLanguage } from './SupportedLanguage';
import { SupportedLocale } from './SupportedLocale';

export function localizedLanguageName(language: SupportedLanguage): string;
export function localizedLanguageName(language: SupportedLocale): string;
export function localizedLanguageName(
  language: SupportedLanguage | SupportedLocale,
): string {
  return (
    new Intl.DisplayNames([language], { type: 'language' }).of(language) ??
    language
  );
}

export function toSupportedLocale(
  language: SupportedLanguage,
): SupportedLocale {
  const supportedLanguages: Record<SupportedLanguage, SupportedLocale> = {
    [SupportedLanguage.Bulgarian]: SupportedLocale.Bulgarian,
    [SupportedLanguage.ChineseSimplified]: SupportedLocale.ChineseTraditional,
    [SupportedLanguage.ChineseTraditional]: SupportedLocale.ChineseTraditional,
    [SupportedLanguage.Czech]: SupportedLocale.Czech,
    [SupportedLanguage.Danish]: SupportedLocale.Danish,
    [SupportedLanguage.Dutch]: SupportedLocale.Dutch,
    [SupportedLanguage.English]: SupportedLocale.English,
    [SupportedLanguage.Estonian]: SupportedLocale.Estonian,
    [SupportedLanguage.Finnish]: SupportedLocale.Finnish,
    [SupportedLanguage.French]: SupportedLocale.French,
    [SupportedLanguage.German]: SupportedLocale.German,
    [SupportedLanguage.Hungarian]: SupportedLocale.Hungarian,
    [SupportedLanguage.Icelandic]: SupportedLocale.Icelandic,
    [SupportedLanguage.Indonesian]: SupportedLocale.Indonesian,
    [SupportedLanguage.Italian]: SupportedLocale.Italian,
    [SupportedLanguage.Japanese]: SupportedLocale.Korean,
    [SupportedLanguage.Korean]: SupportedLocale.Korean,
    [SupportedLanguage.Lithuanian]: SupportedLocale.Lithuanian,
    [SupportedLanguage.Norwegian]: SupportedLocale.Norwegian,
    [SupportedLanguage.Polish]: SupportedLocale.Polish,
    [SupportedLanguage.Portuguese]: SupportedLocale.Portuguese,
    [SupportedLanguage.Romanian]: SupportedLocale.Romanian,
    [SupportedLanguage.Russian]: SupportedLocale.Russian,
    [SupportedLanguage.Spanish]: SupportedLocale.Spanish,
    [SupportedLanguage.Swedish]: SupportedLocale.Swedish,
    [SupportedLanguage.Turkish]: SupportedLocale.Turkish,
    [SupportedLanguage.Thai]: SupportedLocale.Thai,
    [SupportedLanguage.Ukrainian]: SupportedLocale.Ukrainian,
    [SupportedLanguage.Vietnamese]: SupportedLocale.Vietnamese,
  };

  return supportedLanguages[language];
}

export function toSupportedLanguage(
  language: SupportedLocale,
): SupportedLanguage {
  const supportedLanguages: Record<SupportedLocale, SupportedLanguage> = {
    [SupportedLocale.Bulgarian]: SupportedLanguage.Bulgarian,
    [SupportedLocale.ChineseTraditional]: SupportedLanguage.ChineseTraditional,
    [SupportedLocale.Czech]: SupportedLanguage.Czech,
    [SupportedLocale.Danish]: SupportedLanguage.Danish,
    [SupportedLocale.Dutch]: SupportedLanguage.Dutch,
    [SupportedLocale.English]: SupportedLanguage.English,
    [SupportedLocale.Estonian]: SupportedLanguage.Estonian,
    [SupportedLocale.Finnish]: SupportedLanguage.Finnish,
    [SupportedLocale.French]: SupportedLanguage.French,
    [SupportedLocale.German]: SupportedLanguage.German,
    [SupportedLocale.Hungarian]: SupportedLanguage.Hungarian,
    [SupportedLocale.Icelandic]: SupportedLanguage.Icelandic,
    [SupportedLocale.Indonesian]: SupportedLanguage.Indonesian,
    [SupportedLocale.Italian]: SupportedLanguage.Italian,
    [SupportedLocale.Japanese]: SupportedLanguage.Korean,
    [SupportedLocale.Korean]: SupportedLanguage.Korean,
    [SupportedLocale.Lithuanian]: SupportedLanguage.Lithuanian,
    [SupportedLocale.Norwegian]: SupportedLanguage.Norwegian,
    [SupportedLocale.Polish]: SupportedLanguage.Polish,
    [SupportedLocale.Portuguese]: SupportedLanguage.Portuguese,
    [SupportedLocale.Romanian]: SupportedLanguage.Romanian,
    [SupportedLocale.Russian]: SupportedLanguage.Russian,
    [SupportedLocale.Spanish]: SupportedLanguage.Spanish,
    [SupportedLocale.Swedish]: SupportedLanguage.Swedish,
    [SupportedLocale.Turkish]: SupportedLanguage.Turkish,
    [SupportedLocale.Thai]: SupportedLanguage.Thai,
    [SupportedLocale.Ukrainian]: SupportedLanguage.Ukrainian,
    [SupportedLocale.Vietnamese]: SupportedLanguage.Vietnamese,
  };

  return supportedLanguages[language];
}
